import React from 'react'

const GamePrev = ({sport, game, onClick, isActive}) => {
    // Ensure team names are truncated if longer than 15 characters
    const displayAwayTeam = game.awayTeam;
    const displayHomeTeam = game.homeTeam;
    
    return(
        <button 
            onClick={onClick}
            className={`w-full text-left p-3 rounded-lg transition-colors ${
                isActive 
                    ? 'bg-brand-red-50 dark:bg-brand-red-900 border-brand-red-200 dark:border-brand-red-800' 
                    : 'bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700'
            } border border-gray-200 dark:border-gray-700 shadow-sm`}
        >
            <div className="flex items-center justify-between">
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 text-sm font-medium text-gray-900 dark:text-white">
                        <span className="truncate">{displayAwayTeam}</span>
                        <span className="text-gray-500 dark:text-gray-400">@</span>
                        <span className="truncate">{displayHomeTeam}</span>
                    </div>
                    <div className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                        {game.dateObj.time}
                    </div>
                </div>
                {game.matchCount !== null && game.matchCount > 0 && (
                    <div className="ml-2">
                        <span className="inline-flex items-center px-2 py-1 text-xs font-medium rounded-full bg-brand-red-100 dark:bg-brand-red-800 text-brand-red-700 dark:text-brand-red-100">
                            {game.matchCount}
                        </span>
                    </div>
                )}
            </div>
        </button>
    )
}

export default GamePrev